import React from 'react';
import { TrendingUp } from 'lucide-react';

interface XPNotificationProps {
  xp: number;
  onClose: () => void;
}

const XPNotification: React.FC<XPNotificationProps> = ({ xp, onClose }) => {
  React.useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 2000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div 
      className="fixed top-4 right-4 z-[9999] bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-4 py-3 rounded-lg shadow-lg flex items-center"
      style={{
        animation: 'slide-in 0.3s ease-out forwards, fade-out 0.3s ease-out 1.7s forwards',
        transform: 'translateX(0)',
        opacity: 1
      }}
    >
      <TrendingUp className="w-5 h-5 mr-2" />
      <span className="font-medium">+{xp} XP</span>
    </div>
  );
};

export default XPNotification;